export const Country = {
    russia: 1
};

export const GeoType = {
    country: 0,
    region: 1,
    city: 2
};

export const Profile = {
    default: 0,
    trucker: 1,
    owner_trucker: 6,
    exp_trucker: 5,
    exp: 2,
    dispatcher: 4,
    owner: 3,
    insurance: 7,
    jur: 10,
    autoService: 22,
    it: 23,
};

export const PaySource = {
    atis: 0,
    bankCard: 1,
};

export const PaymentType = {
    payByBankCard: 0,
    payFromVirtualAccount: 1,
    topUpVirtualAccount: 2
};

export const PeriodType = {
    day: 1,
    month: 2,
};

export const EnablerFeatures = {
    inviteAllTruckersToBoardsInformer: 'inviteAllTruckersToBoardsInformer',
    selectAndInviteAllTruckersInformer: 'selectAndInviteAllTruckersInformer'
};
